<template>
    <v-dialog v-model="dialog" width="320" persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light>
            <v-card-title> {{ title }} <v-spacer /> <v-icon @click="dialog = false">mdi-close</v-icon> </v-card-title>
            <v-card-text class="py-0">
                <v-row>
                    <v-col cols="12"> <autocomplete-user-group v-model="inputs._group" :items="userTypes" label="사용자 그룹" v-bind="attrs_input" /> </v-col>
                    <v-col cols="12"> <v-text-field v-model="inputs.name" label="지점명" v-bind="attrs_input" /> </v-col>
                    <v-col cols="12"> <v-text-field v-model="inputs.username" :disabled="!isCreate" label="아이디" v-bind="attrs_input" /> </v-col>
                    <v-col cols="12"> <v-text-field v-model="inputs.password" label="비밀번호" v-bind="attrs_input" /> </v-col>
                    <v-col cols="12">
                        <v-switch v-model="inputs.isOrderDisabled" label="발주제한" v-bind="attrs_switch" class="d-inline-block" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { attrs_input, attrs_switch } from "@/assets/variables";

import AutocompleteUserGroup from "../dumb/autocomplete-user-group.vue";

const initInputs = () => ({
    _group: null,
    name: "",
    username: "",
    password: "",
    isOrderDisabled: false,
});

const userTypes = [];

export default {
    components: {
        AutocompleteUserGroup,
    },
    props: {
        _id: { type: String, default: null },
        // value: { type: Object, default: () => ({}) }, // user
    },
    data: () => ({
        inputs: initInputs(),

        dialog: false,
        userTypes,

        attrs_input,
        attrs_switch,
    }),
    computed: {
        isCreate() {
            return !this._id;
        },
        title() {
            let title = "사용자";
            title += this.isCreate ? " 생성" : " 수정";
            return title;
        },
    },
    watch: {
        dialog() {
            if (this.dialog) this.init();
        },
    },
    methods: {
        async init() {
            if (this.isCreate) this.inputs = initInputs();
            else {
                let { _id } = this;
                let { user } = await api.console.users.get({ _id });
                if (user?.password) user.password = CryptoAES.decrypt(user.password);
                this.inputs = user;
            }
        },
        async save() {
            try {
                let { password, ...user } = this.inputs;

                if (!password) throw new Error("비밀번호를 입력해주세요.");

                if (password) password = CryptoAES.encrypt(password);
                user = { ...user, password };
                if (!password) delete user.password;

                let { post, put } = api.console.users;
                user = (await (this.isCreate ? post : put)(user))?.user;

                console.log({ user });

                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.$emit("input", user);
                this.dialog = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>
